import * as React from "react";
import IntakeSettingsStore from "../../../../stores/IntakeSettingsStore";
import {
  GetIntakeSettings,
  UpdateIntakeSettings
} from "../../../../actions/IntakeSettingActions";
class IntakeSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSettings: {
        iaDuration: 45,
        directoryDuration: 46,
        rejectDupe: true,
        skipRejectDelete: true,
        defaultOCRQual: "1",
        ocrType: "smartOCR",
        doesIronServiceExist: false,
        doesOcrServiceExist: false,
        autoRotatePages: true
      }
    };
    this.onIntakeSettingsUpdate = this.onIntakeSettingsUpdate.bind(this);
    this.toggleRejectDupes = this.toggleRejectDupes.bind(this);
    this.toggleAllowDupes = this.toggleAllowDupes.bind(this);
    this.toggleRemoveDollarSigns = this.toggleRemoveDollarSigns.bind(this);
    this.onEditIADuration = this.onEditIADuration.bind(this);
    this.onEditDirDuration = this.onEditDirDuration.bind(this);
    this.onOCRQualityChange = this.onOCRQualityChange.bind(this);
    this.onOCRMethodChange = this.onOCRMethodChange.bind(this);
    this.saveIntakeSettings = this.saveIntakeSettings.bind(this);
    this.toggleAutoRotatePages = this.toggleAutoRotatePages.bind(this);
  }
  componentDidMount() {
    IntakeSettingsStore.addChangeListener(this.onIntakeSettingsUpdate);
    GetIntakeSettings();
  }
  componentWillUnmount() {
    IntakeSettingsStore.removeChangeListener(this.onIntakeSettingsUpdate);
  }
  onIntakeSettingsUpdate() {
    let settings = IntakeSettingsStore.getIntakeSettings();
    this.setState({ currentSettings: settings });
  }
  toggleRejectDupes() {
    let cs = this.state.currentSettings;
    cs.rejectDupe = !cs.rejectDupe;
    this.setState({ currentSettings: cs });
  }
  toggleRemoveDollarSigns() {
    let cs = this.state.currentSettings;
    cs.removeDollarSignsFromOCR = !cs.removeDollarSignsFromOCR;
    this.setState({ currentSettings: cs });
  }
  toggleAllowDupes() {
    let cs = this.state.currentSettings;
    cs.skipRejectDelete = !cs.skipRejectDelete;
    this.setState({ currentSettings: cs });
  }
  toggleAutoRotatePages() {
    let cs = this.state.currentSettings;
    cs.autoRotatePages = !cs.autoRotatePages;
    this.setState({ currentSettings: cs });
  }
  onEditIADuration(e) {
    let settings = this.state.currentSettings;
    if (e.target.value === "") {
      settings.iaDuration = "";
      this.setState({ currentSettings: settings });
    } else if (!isNaN(e.target.value)) {
      settings.iaDuration = parseInt(e.target.value);
      this.setState({ currentSettings: settings });
    }
  }
  onEditDirDuration(e) {
    let settings = this.state.currentSettings;
    if (e.target.value === "") {
      settings.directoryDuration = "";
      this.setState({ currentSettings: settings });
    } else if (!isNaN(e.target.value)) {
      settings.directoryDuration = parseInt(e.target.value);
      this.setState({ currentSettings: settings });
    }
  }
  onOCRQualityChange(e) {
    let settings = this.state.currentSettings;
    settings.defaultOCRQual = parseInt(e.target.value);
    this.setState({ currentSettings: settings });
  }
  onOCRMethodChange(value) {
    let settings = this.state.currentSettings;
    settings.defaultOCRType = value;
    this.setState({ currentSettings: settings });
  }
  saveIntakeSettings() {
    UpdateIntakeSettings(this.state.currentSettings);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container" }, this.state.currentSettings !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { maxWidth: "60%", margin: "12px" },
        id: "intakeInfo",
        className: "card"
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-gear" }), " Intake Settings"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtLDAP", className: "form-label" }, "InboundAutomation check interval", " ", /* @__PURE__ */ React.createElement("span", { style: { color: "#C1C1C1" } }, "(seconds)")), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          id: "txtLDAP",
          value: this.state.currentSettings.iaDuration,
          onChange: this.onEditIADuration,
          placeholder: "seconds"
        }
      )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtLDAP", className: "form-label" }, "Directory check interval", " ", /* @__PURE__ */ React.createElement("span", { style: { color: "#C1C1C1" } }, "(seconds)")), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          id: "txtLDAP",
          value: this.state.currentSettings.directoryDuration,
          onChange: this.onEditDirDuration,
          placeholder: "seconds"
        }
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "rejectDupeswitch" }, "Reject duplicate uploads"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.rejectDupe,
          onChange: this.toggleRejectDupes,
          id: "rejectDupeswitch"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "allowDupeswitch" }, "Allow duplicate when deleted"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.skipRejectDelete,
          onChange: this.toggleAllowDupes,
          id: "allowDupeswitch"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "rejectDupeswitch" }, "Remove Dollar Sign from OCR Results"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.removeDollarSignsFromOCR,
          onChange: this.toggleRemoveDollarSigns,
          id: "removeDollarSignsSwitch"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "autoRotate" }, "Attempt to auto rotate pages"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          checked: this.state.currentSettings.autoRotatePages,
          onChange: this.toggleAutoRotatePages,
          id: "removeDollarSignsSwitch"
        }
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("label", { className: "form-label", htmlFor: "allowDupeswitch" }, "Default OCR Quality"), /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select",
          "aria-label": "Default OCR Quality",
          value: this.state.currentSettings.defaultOCRQual,
          onChange: this.onOCRQualityChange
        },
        /* @__PURE__ */ React.createElement("option", { value: "1" }, "Standard"),
        /* @__PURE__ */ React.createElement("option", { value: "2" }, "High"),
        /* @__PURE__ */ React.createElement("option", { value: "3" }, "Highest")
      ), /* @__PURE__ */ React.createElement("label", { className: "form-label", htmlFor: "allowDupeswitch" }, "Default OCR Method"), /* @__PURE__ */ React.createElement("div", { className: "" }, this.state.currentSettings.doesOcrServiceExist && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "radio",
          name: "flexRadioDefault",
          id: "ocrRadioSmartOCR",
          onChange: () => this.onOCRMethodChange("full"),
          checked: this.state.currentSettings.defaultOCRType === "full" || this.state.currentSettings.defaultOCRType === "smart"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "form-check-label",
          htmlFor: "flexRadioDefault2"
        },
        "OCR 1.0"
      )), (this.state.currentSettings.defaultOCRType === "full" || this.state.currentSettings.defaultOCRType === "smart") && /* @__PURE__ */ React.createElement("span", { className: "" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          id: "fullOcr",
          onChange: () => this.onOCRMethodChange("full"),
          checked: this.state.currentSettings.defaultOCRType === "full"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "form-check-label",
          htmlFor: "preSplitChange"
        },
        "Full"
      )), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch ms-3" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "checkbox",
          id: "barcodeSplit",
          onChange: () => this.onOCRMethodChange("smart"),
          checked: this.state.currentSettings.defaultOCRType === "smart"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "form-check-label",
          htmlFor: "barcodeSplit"
        },
        "Smart"
      )))), this.state.currentSettings.doesIronServiceExist && /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-check-input",
          type: "radio",
          name: "flexRadioDefault",
          id: "ocrRadioIronOCR",
          onChange: () => this.onOCRMethodChange("iron"),
          checked: this.state.currentSettings.defaultOCRType === "iron"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "form-check-label",
          htmlFor: "flexRadioDefault2"
        },
        "OCR 2.0"
      ))), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success btn-sm mt-2",
          onClick: this.saveIntakeSettings
        },
        "Save"
      ))
    ));
  }
}
export default IntakeSettings;
